import { hrmsGet, hrmsPost, hrmsPatch, hrmsDel } from "../api/api";
import sessionDB from "../utils/sessionDB";

function transformServices(raw) {
  const servicesObj = raw.Services ?? raw;
  return Object.entries(servicesObj).map(([serviceName, modules]) => ({
    id: serviceName,
    name: serviceName,
    modules: Object.entries(modules).map(([moduleName, subModules]) => ({
      id: `${serviceName}-${moduleName}`,
      name: moduleName,
      sub_modules: Object.entries(subModules).map(([subModuleName, perms]) => ({
        id: `${serviceName}-${moduleName}-${subModuleName}`,
        name: subModuleName,
        permissions: perms.map((p) => ({
          id: String(p.serviceId),
          name: p.featureName,
        })),
      })),
    })),
  }));
}

export async function fetchServices() {
  const json = await hrmsGet("/org-role-services/get-services", "HR19S");
  const raw = json.data ?? json;
  return transformServices(raw);
}

export async function assignRoleServices(roleId, serviceIds) {
  for (const id of serviceIds) {
    await hrmsPost("/org-role-services/add", { roleId, serviceId: Number(id), isEnabled: true }, "HR19S");
  }
}

export async function updateRoleServices(roleId, serviceChanges) {
  for (const { id, isEnabled } of serviceChanges) {
    await hrmsPatch(`/org-role-services/update/${roleId}/${id}/toggle`, { isEnabled }, "HR19U");
  }
}

export async function fetchRoles() {
  const tenantId = sessionDB.getTenantId();
  const json = await hrmsGet(`/org/roles?tenantId=${tenantId}&page=0&size=10`, "HR19S");
  const raw = json.data ?? json;
  const list = Array.isArray(raw) ? raw : (raw.content ?? raw.roles ?? []);
  return list.map((r) => {
    const date = new Date(r.createdOn);
    const createdOn = date.toLocaleString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).replace(",", "");
    return {
      id: Number(r.roleId),
      name: r.roleName,
      type: "Custom",
      description: r.roleDescription ?? "",
      usersAssigned: r.userCount ?? 0,
      createdOn,
      permissions: [],
    };
  });
}

async function fetchRoleServices(roleId) {
  try {
    const json = await hrmsGet(`/org-role-services/role/${roleId}?page=0&size=500`, "HR19S");
    const raw = json.data ?? json;
    const list = Array.isArray(raw) ? raw : (raw.content ?? raw.services ?? []);
    return list.filter((item) => item.isEnabled !== false).map((item) => String(item.serviceId));
  } catch (error) {
    if (error.status === 404) return [];
    throw error;
  }
}

export async function fetchRoleById(id) {
  const [roles, permissions] = await Promise.all([fetchRoles(), fetchRoleServices(Number(id))]);
  const role = roles.find((r) => r.id === Number(id));
  if (!role) throw new Error(`Role ${id} not found`);
  return { ...role, permissions };
}

export async function createRole({ name, description }) {
  const trimmed = name.trim();
  try {
    const payload = { roleName: trimmed, description: description.trim(), tenantId: sessionDB.getTenantId() };
    const json = await hrmsPost(`/org/roles`, payload, "HR19S");
    const data = json.data ?? json;
    return { id: Number(data.roleId), name: trimmed };
  } catch (error) {
    if (error.status === 409) {
      throw new Error(`A role named "${trimmed}" already exists.`);
    }
    throw error;
  }
}

export async function updateRole() { }

export async function deleteRole(id) {
  await hrmsDel(`/org/roles/${id}`, undefined, "HR19S");
}
